import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { AddressesText } from "../../Addresses/Addresses-types";
export const PrimaryAddressText = ({ errorText }) => (_jsx(Typography, { children: errorText ? errorText : AddressesText.THIS_IS_PRIMARY }));
